// Loads ad-platform tags (only platforms set to "active" in Admin → Ad Platforms) and fires form conversions.
const API = process.env.REACT_APP_BACKEND_URL;
let config = {};
let loaded = false;

const addScript = (src, inline) => {
  const s = document.createElement('script');
  s.async = true;
  if (src) s.src = src;
  if (inline) s.text = inline;
  document.head.appendChild(s);
};

const LOADERS = {
  google_ads: ({ id }) => {
    addScript(`https://www.googletagmanager.com/gtag/js?id=${id}`);
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
    window.gtag('js', new Date());
    window.gtag('config', id);
  },
  microsoft_ads: ({ id }) => addScript(null, `(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"${id}",enableAutoSpaTracking:true};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");`),
  yandex_direct: ({ id }) => addScript(null, `(function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};m[i].l=1*new Date();k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})(window,document,"script","https://mc.yandex.ru/metrika/tag.js","ym");ym(${id},"init",{clickmap:true,trackLinks:true,accurateTrackBounce:true});`),
  linkedin_ads: ({ id }) => {
    window._linkedin_partner_id = id;
    window._linkedin_data_partner_ids = [...(window._linkedin_data_partner_ids || []), id];
    addScript('https://snap.licdn.com/li.lms-analytics/insight.min.js');
  },
  meta_ads: ({ id }) => addScript(null, `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init','${id}');fbq('track','PageView');`),
};

export const loadTrackers = async () => {
  if (loaded) return;
  loaded = true;
  try {
    const r = await fetch(`${API}/api/tracking-config`);
    config = r.ok ? await r.json() : {};
  } catch { config = {}; }
  Object.entries(config).forEach(([key, c]) => LOADERS[key]?.(c));
};

// type: 'quote' | 'contact'
export const trackConversion = (type) => {
  const g = config.google_ads;
  const label = g?.[`label_${type}`];
  if (g && label && window.gtag) window.gtag('event', 'conversion', { send_to: `${g.id}/${label}` });
  if (config.microsoft_ads && window.uetq) window.uetq.push('event', `submit_${type}`, {});
  if (config.yandex_direct && window.ym) window.ym(Number(config.yandex_direct.id), 'reachGoal', `submit_${type}`);
  const li = config.linkedin_ads?.[`label_${type}`];
  if (li && window.lintrk) window.lintrk('track', { conversion_id: Number(li) });
  if (config.meta_ads && window.fbq) window.fbq('track', type === 'quote' ? 'Lead' : 'Contact');
};
